export default __webpack_public_path__ + "static/media/dp-1.4dc38db4.png";